module.exports = __webpack_public_path__ + "static/media/bg_TM.1fc78e9f.jpg";